<template>
  <div class="hzc-industry-dynamics no-li">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/oilBenzene')">石油苯</span> > <span
        @click="back('/oilBenzene/twoPage/stock')" style="cursor: pointer">库存</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络" }}</span>
      </div>
      <div class="echarts">
        <div id="myChart" style="width: 900px;height:340px;"></div>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
    </div>
  </div>
</template>

<script>
import {
  stockDetail,
  stockDetailData
} from '@/api/oilBenzene'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      id: '',
      option: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          x: 'center',      //可设定图例在左、右、居中
          y: 'bottom',
          data: []
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月']
        },
        yAxis: {},
        series: [
        ],
        grid: {
          x: 100,
          y: 50,
          x2: 10,
          y2: 50
        },
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getDetail(this.$route.query.id);
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail(pageParams) {
      stockDetail(pageParams).then(res => {
        this.row = res.data;
        this.getMapData()
      })
    },
    /**
     * 获取地图信息
     */
    getMapData() {
      this.option['series'] = [];
      this.option['legend'].data = [];
      stockDetailData({dictId:'670', endTime:this.row.showYearTime}).then(res => {
        res.data.dataList.map(item => {
          let obj = {
            name: item.yearName,
            type: "line",
            connectNulls:true,
            data: item.priceList
          }
          this.option.series.push(obj);
          this.option.legend.data.push(item.yearName)
        })
        this.option['xAxis']['data'] = res.data['coordinate'];
        this.drawChart(this.option);
      })
    },
    /**
     * 加载地图
     */
    drawChart(option) {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      myChart.setOption(option);
    },
    /**
     * 返回
     */
    back(url) {
      this.$router.push({path: url});
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin: 16px auto 0;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }

      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }

    .bom {
      padding: 16px 40px;

      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
